import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const ButtonStyled = styled.button`
  flex: 1;
  display: flex;
  gap: 8px;
  align-content: center;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 0 16px;
  outline: none;
  color: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.GreyDarkest })};
  background: ${ct({ Dark: Colors.Transparent, Light: Colors.Transparent })};
  border: none;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;

  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

  &[data-do-not-wrap-text='true'] {
    white-space: nowrap;
  }

  &[aria-selected='true'] {
    color: ${ct({ Dark: Colors.BrandBlue, Light: Colors.BrandBlue })};
    background: ${ct({ Dark: Colors.BrandBlueLightest, Light: Colors.BrandBlueLightest })};
  }

  &:not(:disabled):hover {
    color: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
    background: ${ct({ Dark: Colors.Light, Light: Colors.Light })};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${ct({ Dark: Colors.AquaMiddle, Light: Colors.AquaMiddle })};
    z-index: 1;
  }

  &:disabled {
    cursor: unset;
  }

  &:not([aria-selected='true']):disabled {
    color: ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};
    background: ${ct({ Dark: Colors.Transparent, Light: Colors.Transparent })};
  }
`;

export const SingleButtonSelectStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 4px;
  padding: 3px;
  border: 1px solid ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};

  &[data-use-scroll='true'] {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: auto;
  }
`;
